import { platform } from "utils/api/generated/manucoApi";

// Issue #23 (rechten F4 §2): openstaande acties van de assistent. Een destructieve MCP-actie (Exact-schrijven, wissen,
// bankprofiel activeren, …) voert niets uit maar wacht hier op de eigenaar. Iedereen ziet enkel de eigen acties (de procs
// filteren op de beller). Uitvoeren vraagt step-up: apiClient vraagt dan zelf een sterker token en probeert één keer
// opnieuw. Een 403 bij uitvoeren (rol, niveau, bereik van de onderliggende operatie) hoort bij de actie, niet bij de
// pagina: geen doorverwijzing naar /forbidden.

const READ = { retries: 1, suppressAuthRedirect: true };
const WRITE = { retries: 0, suppressAuthRedirect: true };
const list = (payload) => (Array.isArray(payload) ? payload : []);

// GET /v2/pending-actions?includeDecided=&top=
export async function listPendingActions(tokenProvider, { includeDecided = false, top } = {}) {
  return list(await platform.pendingActionList(tokenProvider, { includeDecided: Boolean(includeDecided), top: top ?? undefined }, READ));
}

// Enkel het aantal openstaande (sidebar-badge); stil: een fout geeft null.
export async function countPendingActions(tokenProvider) {
  try {
    const rows = await platform.pendingActionList(tokenProvider, { includeDecided: false }, { retries: 0, suppressAuthRedirect: true });
    return list(rows).filter((r) => String(r?.status || "").toUpperCase() === "PENDING").length;
  } catch {
    return null;
  }
}

// POST /v2/pending-actions/{id}/execute → { id, status, ok, resultJson, errorCode, errorMessage }
export function executePendingAction(tokenProvider, { id }) {
  return platform.pendingActionExecute(tokenProvider, { id }, WRITE);
}

// POST /v2/pending-actions/{id}/reject { reason } → { id, status }
export function rejectPendingAction(tokenProvider, { id, reason }) {
  return platform.pendingActionReject(tokenProvider, { id, reason: String(reason || "").trim() }, WRITE);
}
